import {addConfigToServiceFunction} from "@montana/services/http";
import {select} from "redux-saga/effects";
import {IStoreState} from "@montana/store/store";
import {ISettingsContainerState} from "../settings/settings";
import {getPath} from "@montana/helpers/location.helper";
import {resolveCurrentUrlLocale} from "@montana/helpers/market.helper";
import {IDynamicSettingsContainerState} from "../dynamic-settings/dynamic-settings";
import {IRouterContainerState} from "../router";

export function* connectServiceFunctions<TFunctions extends any[]>(...serviceFunctions: TFunctions): any {
    const { language, market, customerMode }: ISettingsContainerState = yield select((s: IStoreState) => ({ ...s.settings }));

    return serviceFunctions.map(f => addConfigToServiceFunction({ market, language, customerMode }, f));
}

export function* selectCurrentUrlLocale(fallbackLanguage?: string): any {
    const {
        dynamicSettings,
        router,
        settings
    }: {
        dynamicSettings: IDynamicSettingsContainerState;
        router: IRouterContainerState;
        settings: ISettingsContainerState;
    } = yield select((s: IStoreState) => ({
        dynamicSettings: s.dynamicSettings,
        router: s.router,
        settings: s.settings
    }));

    const path = router.location ? getPath(router.location) : undefined;

    return resolveCurrentUrlLocale(path, fallbackLanguage, dynamicSettings.language, settings.language);
}
